
import Tabbar from 'vux/src/components/tabbar/tabbar.vue'
import Icon from 'vux/src/components/icon/index.vue'
import TabbarItem from 'vux/src/components/tabbar/tabbar-item.vue'
import XHeader from 'vux/src/components/x-header/index.vue'
import Loading from 'vux/src/components/loading/index.vue'
import ViewBox from 'vux/src/components/view-box/index.vue'

import { mapGetters } from "vuex";

export default {
computed: {

headShow() {
return this.$store.getters.headShow;
},
loading() {
return this.$store.getters.loading;
},
footerShow() {
return this.$store.getters.footerShow;
},
pageTitle() {
return this.$store.getters.pageTitle;
},
containsChar1() {

console.log(this.demand);
return this.demand.includes("点赞");
},
containsChar2() {

return this.demand.includes("评论");
},
containsChar3() {

return this.demand.includes("转发");
},
containsChar4() {

return this.demand.includes("在看");
},
containsChar5() {

return this.demand.includes("举报");
},
containsChar6() {

return this.demand.includes("关注");
},
containsChar7() {

return this.demand.includes("投票");
},
containsChar8() {

if(this.demand.includes("投票") && this.urls === 2){

return true;
}else{
return false;
}

},
},
components: {
Tabbar,
TabbarItem,
XHeader,
Loading,
ViewBox,
Icon,
},
data() {
return {
taskname: "",
totalData: [],
uploader: [],
uploader2: [],
uploader3: [],
uploader4: [],
uploader5: [],
uploader6: [],
uploader7: [],
uploader8: [],
notes: "",
value: "",
value2: "",
demand: "",
bumen: "",
urls:"",
showPicker: "",
columns: [],
filenames2: [],
filenames22: [],
filenames222: [],
filenames2222: [],
filenames22222: [],
filenames222222: [],
filenames2222222: [],
filenames22222222: [],
filedata: "",
filedatazf: "",
filedatazk: "",
filedatadz: "",
filedatapl: "",
paths: [],
};
},
mounted() {
this.$store.commit("UPDATE_PAGE_TITLE", "任务提交");
this.showPicker = this.$route.params.titles;
this.value2 = this.$route.params.id;
this.demand = this.$route.params.demand;
this.bumen = this.$route.params.bumen;
this.urls = this.$route.params.urls.length;

},
methods: {




subConfirm() {
console.log(this.uploader[0]);









var time = this.gettime();
console.log(time);
this.renwutijiao(time);
},
doPage(wxid) {
this.$axios
.get(
this.$httpUrl +
"/daren/personwork/list?ryid=" +
wxid +
"&status=" +
"未完成"
)
.then((res) => res.data)
.then((res) => {
console.log(res);
this.totalData = res.rows;
this.totalData.forEach((item) => {
console.log(item.title);
this.$set(this.columns, this.columns.length, item.title);
});
});
},

renwutijiao(time) {
if (this.demand.includes("点赞")) {
if (this.filenames2.length > 0) {
} else {
console.log(this.filenames2.length)
alert("有未填项，请完善后再提交1");
return;
}
}
if (this.demand.includes("评论")) {
if (this.filenames22.length > 0) {
} else {
console.log(this.filenames22.length)
alert("有未填项，请完善后再提交2");
return;
}
}
if (this.demand.includes("转发")) {
if (this.filenames222.length > 0) {
} else {
console.log(this.filenames222.length)
alert("有未填项，请完善后再提交3");
return;
}
}
if (this.demand.includes("在看")) {
if (this.filenames2222.length > 0) {
} else {
console.log(this.filenames2222.length)
alert("有未填项，请完善后再提交4");
return;
}
}
if (this.demand.includes("举报")) {
if (this.filenames22222.length > 0) {
} else {
console.log(this.filenames22222.length)
alert("有未填项，请完善后再提交5");
return;
}
}
if (this.demand.includes("关注")) {
if (this.filenames222222.length > 0) {
} else {
console.log(this.filenames222222.length)
alert("有未填项，请完善后再提交6");
return;
}
}
if (this.demand.includes("投票")) {
if (this.filenames2222222.length > 0) {
} else {
console.log(this.filenames2222222.length)
alert("有未填项，请完善后再提交7");
return;
}
}
if (this.demand.includes("投票2")) {
if (this.filenames22222222.length > 0) {
} else {
console.log(this.filenames22222222.length)
alert("有未填项，请完善后再提交8");
return;
}
}


if (1 === 1) {
this.$axios
.put(this.$httpUrl + "/daren/personwork", {
id: this.value2,
message: this.notes,
likedfile: this.filenames2.join(","),
commentfile: this.filenames22.join(","),
transmitfile: this.filenames222.join(","),
watchingfile: this.filenames2222.join(","),
reportfile: this.filenames22222.join(","),
gzfile: this.filenames222222.join(","),
tpfile: this.filenames2222222.join(",") +","+ this.filenames22222222.join(","),
wctime: time,
status: "已提交未审核",
authority: "1",
})
.then((res) => res.data)
.then((res) => {
console.log(res);
if (res.code === 200) {
this.$router.push("/memberHome/dashbord");
}
});
} else {
alert("有未填项，请完善后再提交");
}
},
imageCompress(url, type, size) {
return new Promise((resolve, reject) => {
let www = 0;
let hhh = 0;
if (size > 10000000) {
console.log(size, "size");
www = 50;
hhh = 50;
}else if (size > 5000000) {
console.log(size, "size");
www = 20;
hhh = 20;
} else if (size > 3000000) {
www = 10;
hhh = 10;
} else if (size > 1000000) {
www = 5;
hhh = 5;
} else {
www = 3;
hhh = 3;
}
const img = new Image();
img.src = url;
let files = {};
img.onload = async () => {
const canvas = document.createElement("canvas"); 
const context = canvas.getContext("2d");
let w = img.width / www;
let h = img.height / hhh;
canvas.width = w;
canvas.height = h;
context.clearRect(0, 0, 0, w, h);
context.drawImage(img, 0, 0, w, h);
let base64 = canvas.toDataURL(type, 0.9);
resolve(base64);
};
});
},
base64ToFile(base64, filename, mimeType) {
const byteCharacters = atob(base64.split(",")[1]);
const byteNumbers = new Array(byteCharacters.length);
for (let i = 0; i < byteCharacters.length; i++) {
byteNumbers[i] = byteCharacters.charCodeAt(i);
}
const byteArray = new Uint8Array(byteNumbers);
const blob = new Blob([byteArray], {
type: mimeType,
});


const file = new File([blob], filename, {
type: mimeType,
});

return file;
},

afterRead(files, detail) {
const _this = this;

console.log(files.file.size, "压缩前");

files.content = files.content.replace(
"data:application/octet-stream;",
`data:image/png;`
);
this.filedata = 1;
let base = files.content;


let name = this.bumen.replace(/\//g, "") + files.file.name;
this.imageCompress(files.content, files.file.type, files.file.size).then(
(res) => {
files.content = res;

const tempFile = _this.base64ToFile(res, name, files.file.type);
console.log(tempFile, tempFile.size, "压缩后");
_this.handle(tempFile);
}
);





},

afterRead2(files, detail) {

const _this = this;
console.log(files.file.size, "压缩前");
console.log("handle2");
console.log(files.file);
files.content = files.content.replace(
"data:application/octet-stream;",
`data:image/png;`
);
this.filedata = 1;
let base = files.content;


let name = this.bumen.replace(/\//g, "") + files.file.name;
this.imageCompress(files.content, files.file.type).then((res) => {
files.content = res;
const tempFile = _this.base64ToFile(res, name, files.file.type);

console.log(tempFile, tempFile.size, "压缩后");
_this.handle2(tempFile);
});
},

afterRead3(files, detail) {
const _this = this;
console.log(files.file.size, "压缩前");
console.log("handle3");
console.log(files.file);
files.content = files.content.replace(
"data:application/octet-stream;",
`data:image/png;`
);
this.filedata = 1;
let base = files.content;


let name = this.bumen.replace(/\//g, "") + files.file.name;
this.imageCompress(files.content, files.file.type).then((res) => {
files.content = res;

const tempFile = _this.base64ToFile(res, name, files.file.type);
console.log(tempFile, tempFile.size, "压缩后");
_this.handle3(tempFile);
});
},

afterRead4(files, detail) {
const _this = this;
console.log(files.file.size, "压缩前");
console.log("handle4");
console.log(files.file);
files.content = files.content.replace(
"data:application/octet-stream;",
`data:image/png;`
);
this.filedata = 1;
let base = files.content;

let name = this.bumen.replace(/\//g, "") + files.file.name;
console.log(name + "111filename");
this.imageCompress(files.content, files.file.type).then((res) => {
files.content = res;

const tempFile = _this.base64ToFile(res, name, files.file.type);
console.log(tempFile, tempFile.size, "压缩后");
_this.handle4(tempFile);
});
},

afterRead5(files, detail) {
const _this = this;
console.log(files.file.size, "压缩前");
console.log("handle5");
console.log(files.file);
files.content = files.content.replace(
"data:application/octet-stream;",
`data:image/png;`
);
this.filedata = 1;
let base = files.content;
let name = this.bumen.replace(/\//g, "") + files.file.name;








this.imageCompress(files.content, files.file.type).then((res) => {
files.content = res;

const tempFile = _this.base64ToFile(res, name, files.file.type);
console.log(tempFile, tempFile.size, "压缩后");
_this.handle5(tempFile);
});
},

afterRead6(files, detail) {
const _this = this;
console.log(files.file.size, "压缩前");
console.log("handle6");
console.log(files.file);
files.content = files.content.replace(
"data:application/octet-stream;",
`data:image/png;`
);
this.filedata = 1;
let base = files.content;
let name = this.bumen.replace(/\//g, "") + files.file.name;








this.imageCompress(files.content, files.file.type).then((res) => {
files.content = res;

const tempFile = _this.base64ToFile(res, name, files.file.type);
console.log(tempFile, tempFile.size, "压缩后");
_this.handle6(tempFile);
});
},


afterRead7(files, detail) {
const _this = this;
console.log(files.file.size, "压缩前");
console.log("handle7");
console.log(files.file);
files.content = files.content.replace(
"data:application/octet-stream;",
`data:image/png;`
);
this.filedata = 1;
let base = files.content;
let name = this.bumen.replace(/\//g, "") + files.file.name;








this.imageCompress(files.content, files.file.type).then((res) => {
files.content = res;

const tempFile = _this.base64ToFile(res, name, files.file.type);
console.log(tempFile, tempFile.size, "压缩后");
_this.handle7(tempFile);
});
},

afterRead8(files, detail) {
const _this = this;
console.log(files.file.size, "压缩前");
console.log("handle8");
console.log(files.file);
files.content = files.content.replace(
"data:application/octet-stream;",
`data:image/png;`
);
this.filedata = 1;
let base = files.content;
let name = this.bumen.replace(/\//g, "") + files.file.name;








this.imageCompress(files.content, files.file.type).then((res) => {
files.content = res;

const tempFile = _this.base64ToFile(res, name, files.file.type);
console.log(tempFile, tempFile.size, "压缩后");
_this.handle8(tempFile);
});
},


compressImage(file) {

const reader = new FileReader();
reader.readAsDataURL(file);

return new Promise((resolve) => {
reader.onload = (e) => {
const img = new Image();
img.src = e.target.result;
img.onload = () => {

const canvas = document.createElement("canvas");
const ctx = canvas.getContext("2d");
const { width, height } = img;

canvas.width = 100;
canvas.height = 200;
ctx.drawImage(img, 0, 0, width, height);


canvas.toBlob(
(blob) => {
resolve(new File([blob], file.name, { type: "image/jpeg" }));
},
"image/jpeg",
0.7
); // 0.7为压缩质量，可以根据需求调整
};
};
});
},

async onDelete1(file, detail) {
console.log("删除");
this.filenames2.splice(detail.index, 1);
},
async onDelete2(file, detail) {
console.log("删除");
this.filenames22.splice(detail.index, 1);
},
async onDelete3(file, detail) {
console.log("删除");
this.filenames222.splice(detail.index, 1);
},
async onDelete4(file, detail) {
console.log("删除");
this.filenames2222.splice(detail.index, 1);
},
async onDelete5(file, detail) {
console.log("删除");
this.filenames22222.splice(detail.index, 1);
},
async onDelete6(file, detail) {
console.log("删除");
this.filenames222222.splice(detail.index, 1);
},
async onDelete7(file, detail) {
console.log("删除");
this.filenames2222222.splice(detail.index, 1);
},
async onDelete8(file, detail) {
console.log("删除");
this.filenames22222222.splice(detail.index, 1);
},

base64ToFile(base64Data, filename) {

const arr = base64Data.split(",");
const mime = arr[0].match(/:(.*?);/)[1];
const bstr = atob(arr[1]);
let n = bstr.length;
const u8arr = new Uint8Array(n);

while (n--) {
u8arr[n] = bstr.charCodeAt(n);
}


const blob = new Blob([u8arr], { type: mime });


const file = new File([blob], filename, { type: mime });

return file;
},

handle(file) {
console.log("file是什么？")
console.log(file)
var formData = new FormData();
formData.append("file", file); 

this.$axios({
url: this.$httpUrl + "/common/upload",
headers: {
"Content-Type": "multipart/form-data",
},
method: "post",
data: formData,
}) .then((res) => res.data).then((res) => {
this.$set(this.paths, this.paths.length, res.path);
if (res.code === 200) {
console.log(222);
console.log(res.fileName);
this.filedata = 1;
this.filenames2.push(res.fileName);
} else {
alert("上传失败，请重新打开相册选择该照片上传");
alert(res);
}
});
},
handle2(file) {
console.log("file是什么？")
console.log(file)
var formData = new FormData();
formData.append("file", file); 

this.$axios({
url: this.$httpUrl + "/common/upload",
headers: {
"Content-Type": "multipart/form-data",
},
method: "post",
data: formData,
})
.then((res) => res.data)
.then((res) => {
console.log(res);
console.log(res.path);
this.$set(this.paths, this.paths.length, res.path);
if (res.code === 200) {
console.log(222);
console.log(res.fileName);
this.filedata = 1;
this.filenames22.push(res.fileName);
} else {
alert("上传失败，请重新打开相册选择该照片上传");
alert(res);
}
});
},
handle3(file) {
console.log("file是什么？")
console.log(file)
var formData = new FormData();
formData.append("file", file); 

this.$axios({
url: this.$httpUrl + "/common/upload",
headers: {
"Content-Type": "multipart/form-data",
},
method: "post",
data: formData,
})
.then((res) => res.data)
.then((res) => {
console.log(res);
console.log(res.path);
this.$set(this.paths, this.paths.length, res.path);
if (res.code === 200) {
console.log(222);
console.log(res.fileName);
this.filedata = 1;
this.filenames222.push(res.fileName);
} else {
alert("上传失败，请重新打开相册选择该照片上传");
alert(res);
}
});
},
handle4(file) {
console.log("file是什么？")
console.log(file)
var formData = new FormData();
formData.append("file", file); 

this.$axios({
url: this.$httpUrl + "/common/upload",
headers: {
"Content-Type": "multipart/form-data",
},
method: "post",
data: formData,
})
.then((res) => res.data)
.then((res) => {
console.log(res);
console.log(res.path);
this.$set(this.paths, this.paths.length, res.path);
if (res.code === 200) {
console.log(222);
console.log(res.fileName);
this.filedata = 1;
this.filenames2222.push(res.fileName);
} else {
alert("上传失败，请重新打开相册选择该照片上传");
alert(res);
}
});
},
handle5(file) {
console.log("file是什么？")
console.log(file)
var formData = new FormData();
formData.append("file", file); 

this.$axios({
url: this.$httpUrl + "/common/upload",
headers: {
"Content-Type": "multipart/form-data",
},
method: "post",
data: formData,
})
.then((res) => res.data)
.then((res) => {
console.log(res);
console.log(res.path);
this.$set(this.paths, this.paths.length, res.path);
if (res.code === 200) {
console.log(222);
console.log(res.fileName);
this.filedata = 1;
this.filenames22222.push(res.fileName);
} else {
alert("上传失败，请重新打开相册选择该照片上传");
alert(res);
}
});
},
handle6(file) {
console.log("file是什么？")
console.log(file)
var formData = new FormData();
formData.append("file", file); 

this.$axios({
url: this.$httpUrl + "/common/upload",
headers: {
"Content-Type": "multipart/form-data",
},
method: "post",
data: formData,
})
.then((res) => res.data)
.then((res) => {
console.log(res);
console.log(res.path);
this.$set(this.paths, this.paths.length, res.path);
if (res.code === 200) {
console.log(222);
console.log(res.fileName);
this.filedata = 1;
this.filenames222222.push(res.fileName);
} else {
alert("上传失败，请重新打开相册选择该照片上传");
alert(res);
}
});
},

handle7(file) {
console.log("file是什么？")
console.log(file)
var formData = new FormData();
formData.append("file", file); 

this.$axios({
url: this.$httpUrl + "/common/upload",
headers: {
"Content-Type": "multipart/form-data",
},
method: "post",
data: formData,
})
.then((res) => res.data)
.then((res) => {
console.log(res);
console.log(res.path);
this.$set(this.paths, this.paths.length, res.path);
if (res.code === 200) {
console.log(222);
console.log(res.fileName);
this.filedata = 1;
this.filenames2222222.push(res.fileName);
} else {
alert("上传失败，请重新打开相册选择该照片上传");
alert(res);
}
});
},

handle8(file) {
console.log("file是什么？")
console.log(file)
var formData = new FormData();
formData.append("file", file); 

this.$axios({
url: this.$httpUrl + "/common/upload",
headers: {
"Content-Type": "multipart/form-data",
},
method: "post",
data: formData,
})
.then((res) => res.data)
.then((res) => {
console.log(res);
console.log(res.path);
this.$set(this.paths, this.paths.length, res.path);
if (res.code === 200) {
console.log(222);
console.log(res.fileName);
this.filedata = 1;
this.filenames22222222.push(res.fileName);
} else {
alert("上传失败，请重新打开相册选择该照片上传");
alert(res);
}
});
},

gettime() {
console.log("im coming");
var day = new Date();
console.log(day);
let seconds = day.getSeconds();
if (seconds < 10) {

seconds = "0" + seconds;
} else {
seconds = seconds;
}
let minutes = day.getMinutes();
if (minutes < 10) {
minutes = "0" + minutes;
} else {
minutes = minutes;
}
let month = day.getMonth();
if (month < 10) {
month = "0" + month;
}
let time =
day.getFullYear() +
"-" +
(day.getMonth() + 1) +
"-" +
day.getDate() +
" " +
day.getHours() +
":" +
minutes +
":" +
seconds;
return time;
},
},
};



// WEBPACK FOOTER //
// ./src/views/Ttask.vue